var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccuracyCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Progress_icon",
    "data-name": "Progress icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#b72a2a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143555",
    "data-name": "Path 143555",
    d: "M5.215-4.125l2.15-2.15a.676.676,0,0,0,0-.956l-.478-.478a.676.676,0,0,0-.956,0l-2.15,2.15-2.15-2.15a.676.676,0,0,0-.956,0L.2-7.231a.676.676,0,0,0,0,.956l2.15,2.15L.2-1.975a.676.676,0,0,0,0,.956l.478.478a.676.676,0,0,0,.956,0l2.15-2.15,2.15,2.15a.676.676,0,0,0,.956,0l.478-.478a.676.676,0,0,0,0-.956Z",
    transform: "translate(5.719 13.625)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccuracyCross);
export default __webpack_public_path__ + "static/media/IconAccuracyCross.93ed038333e2c11f47d5f7eb319dbfba.svg";
export { ForwardRef as ReactComponent };